import { fn, IInfOperation } from '@common/utils';
import { NavUrlService } from '../../nav';
import { IIAX_WF_Documents_Sub } from '@common/rwf';

/** aktuelles Dokument als Mail versenden  */
export class CtrlRwfSendMail {
    static readonly Template = require("./sendmail.ctrl.html");
    static $inject = ["$http", "NavUrlService", "WFDocument", "Window", "From"];
    constructor(
        $http: ng.IHttpService,
        navUrl: NavUrlService,
        WFDocument: IIAX_WF_Documents_Sub,
        Window: () => kendo.ui.Window,
        private From: string
    ) {
        this.Execute = {
            Enabled: true,
            Execute: () => {
                this.Validate();

                this.InOperation = true;
                return navUrl.NavUrl.then(strNavUrl => {
                    return $http.post("infoma.Web.KWF3/SendDocumentMail?" + fn.EncodeQueryData({ navUrl: strNavUrl.FullUrl }),
                        {
                            WFInstanceId: WFDocument.WorkflowInstanceID,
                            Documents: [WFDocument],
                            From: this.From,
                            To: this.To,
                            CC: this.CC,
                            BCC : this.BCC,
                            Body: this.Body,
                            BodyIsHtml: false,
                            Subject: this.Subject
                        }).then(w => Window().close()).finally(() => {
                            this.InOperation = false;
                        });
                });
            }
        };
    }

    public Validate() {
        if (!this.From)
            throw new Error("Kein Mail - Absender hinterlegt!");
        if (!this.To)
            throw new Error("Mail - Empfänger muss gefüllt werden!");
        if (!this.Subject)
            throw new Error("Mail - Betreff muss gefüllt werden!");
    }

    public InOperation = false;
    public CC = "";
    public BCC = "";
    public To = "";
    public Subject = "";
    public Body = "";
    public readonly Execute: IInfOperation;
}
